// 无人机模式
export default {
    'UM1': 'Take off mode not flying',
    'UM2': 'Failed to execute takeoff',
    'UM3': 'Take off off',
    'UM4': 'Taking off',
    'UM5': 'Take off completed',
    'UM6': 'No flight in landing mode',
    'UM7': 'Landing failed',
    'UM8': 'Stop landing',
    'UM9': 'Landing',
    'UM10': 'Emergency landing',
    'UM11': 'Landing complete',
    'UM12': 'Return flight failed',
    'UM13': 'Suspension of return',
    'UM14': 'Returning to land',
    'UM15': 'Returning',
    'UM16': 'Return to take off point',
    'UM17': 'Return flight completed',
    'UM18': 'Failed to return to the original route',
    'UM19': 'Suspension of return',
    'UM20': 'The original route is returning and landing',
    'UM21': 'Returning home',
    'UM22': 'Return to the take-off point',
    'UM23': 'The original return route is completed',
    'UM24': 'Failed to execute homing',
    'UM25': 'Suspension of homing',
    'UM26': 'Homing and landing',
    'UM27': 'Homing',
    'UM28': 'Fly to the homing point',
    'UM29': 'Homing completed',
    'UM30': 'Pointing out not flying',
    'UM31': 'Failed to execute guidance flight',
    'UM32': 'Stop pointing flight',
    'UM33': 'Pointing out during takeoff',
    'UM34': 'Guidance flight landing',
    'UM35': 'In flight',
    'UM36': 'Hovering process',
    'UM37': 'Fly to the designated point',
    'UM38': 'Perform the preset action',
    'UM39': 'Guide the flight to completion',
    'UM40': 'Circling without flying',
    'UM41': 'Failed to execute the circling flight',
    'UM42': 'Stop circling',
    'UM43': 'Take off in a circle flight',
    'UM44': 'Circling flight landing',
    'UM45': 'Flying around',
    'UM46': 'Hovering process',
    'UM47': 'Fly to the surround point',
    'UM48': 'Perform the preset action',
    'UM49': 'Circle flight complete',
    'UM50': 'No flight in augmentation mode',
    'UM51': 'Unlocking augmentation mode failed',
    'UM52': 'Remote controller control in augmentation mode',
    'UM53': 'Fixed Altitude mode not flying',
    'UM54': 'Unlocking fixed height mode failed',
    'UM55': 'Fixed height mode remote control control',
    'UM56': 'Fixed point mode not flying',
    'UM57': 'Fixed point mode failure',
    'UM58': 'Fixed point mode remote control control',
    'UM59': 'Hover at fixed point',
    'UM60': 'Automatic route not flying',
    'UM61': 'Failed to execute automatic route',
    'UM62': 'Automatic route suspension',
    'UM63': 'Automatic route taking off',
    'UM64': 'Automatic route landing',
    'UM65': 'Automatic route',
    'UM66': 'Hovering process',
    'UM67': 'Fly to waypoint',
    'UM68': 'Perform the preset action',
    'UM69': 'Automatic route completion',
    'default': 'Unknown'
}